import { AuthContext, AuthContextType } from "@/common/authentication";
import { useContext } from "react";

export const useAuth = (): AuthContextType => {
	return useContext(AuthContext);
};
